"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = function Message(props) {
  var messageId = props.messageId,
      values = props.values,
      className = props.className,
      tagName = props.tagName,
      escapeHtml = props.escapeHtml;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var translate = function translate() {
    return t(messageId, values);
  };

  var output = function output() {
    if (escapeHtml) {
      if (tagName == 'p') {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: className,
          dangerouslySetInnerHTML: {
            __html: translate()
          }
        });
      } else if (tagName == 'div') {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: className,
          dangerouslySetInnerHTML: {
            __html: translate()
          }
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: className,
          dangerouslySetInnerHTML: {
            __html: translate()
          }
        });
      }
    } else {
      if (tagName == 'p') {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: className
        }, translate());
      } else if (tagName == 'div') {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: className
        }, translate());
      } else {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: className
        }, translate());
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, output());
};

Message.propTypes = {
  messageId: _propTypes.default.string.isRequired,
  values: _propTypes.default.object,
  className: _propTypes.default.string,
  tagName: _propTypes.default.string,
  escapeHtml: _propTypes.default.bool
};
var _default = Message;
exports.default = _default;